import { LOCALES } from 'i18n/locales';

export const phaseBannerIntl = {
    [LOCALES.ENGLISH]: {
        'phaseBanner.title': 'Public Beta',
        'phaseBanner.message': 'This is a new service - your <link1>feedback</link1> will help us to improve it. Users remain responsible for compliance with all relevant legislation, and should follow applicable safe excavation guidance.',
        'phaseBanner.open.label': 'Open public beta banner',
        'phaseBanner.close.label': 'Close public beta banner'
    },
    [LOCALES.WELSH]: {
        'phaseBanner.title': 'Beta Gyhoeddus',
        'phaseBanner.message': 'Gwasanaeth newydd yw hwn – bydd eich <link1>adborth</link1> yn ein helpu i’w wella. [Users remain responsible for compliance with all relevant legislation, and should follow applicable safe excavation guidance.]',
        'phaseBanner.open.label': 'Agor baner beta gyhoeddus',
        'phaseBanner.close.label': 'Cau baner beta gyhoeddus'
    }
};
